import React from 'react';
import DirectNavigationModel from '../DirectNavigationModel';
import {PropTypes} from 'prop-types';
import {Button} from '@homeaway/react-buttons';
import UIHelper from 'virtual-tour-viewer/src/utils/UIHelper';

import './SpaceView.less';
import LocaleContext from '../../../../../Contexts/Locale/Context';
import AbacusContext from '../../../../../Contexts/Abacus/Context';

class SpaceView extends React.Component {
    _onSpaceClick = () => {
        if (this.props.onSpaceClick) {
            this.props.onSpaceClick(this.props.space);
        }
    };

    _getImageUrl = (space, useMediaGateway) => {
        const imageName = useMediaGateway
            ? space.landingSphere.mediaGatewayURL
            : space.landingSphere.imageURI;
        return UIHelper.getImageUrlFromName(imageName, 'q2', useMediaGateway);
    };

    render() {
        let {space, useMediaGateway} = this.props;
        // TODO: Display for Space index?
        /* todo: Fix menu width for long text, such as an unfound translation*/
        return (
            <li className={`Space${space.active ? ' current' : ''}`}>
                <LocaleContext.Consumer>
                    {(getTranslation) => (
                        <AbacusContext.Consumer>
                            {(experiments) => (
                                <Button
                                    disabled={space.active}
                                    onClick={this._onSpaceClick}
                                    label={
                                        <React.Fragment>
                                            {space.landingSphere ? (
                                                <img
                                                    src={this._getImageUrl(space, useMediaGateway)}
                                                    className={'img-rounded'}
                                                />
                                            ) : null}
                                            <div className={'SpaceName'}>
                                                {getTranslation(
                                                    space.labelTableOverride || 'spaceLabels',
                                                    space.spaceType
                                                )}
                                            </div>
                                        </React.Fragment>
                                    }
                                />
                            )}
                        </AbacusContext.Consumer>
                    )}
                </LocaleContext.Consumer>
            </li>
        );
    }
}

SpaceView.propTypes = {
    space: DirectNavigationModel.spaceType.isRequired,
    onSpaceClick: PropTypes.func,
    useMediaGateway: PropTypes.bool,
};

export default SpaceView;
